<template>
  <div class="card modal-card width-535">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <div class="center">
          <div class="columns">
            <div class="column">
              <h1 class="title is-size-4">
                {{ traduction.title }}
              </h1>
            </div>
          </div>
        </div>
        <div>
          <div class="columns"
            v-if="isFromLigneFace && !isLogistique">
            <div class="column center">
                <date-picker :dates='intervalDeDate'
                            :updateEndDateAtChangeStartDate="false"
                            position="is-top-left"
                            :customMove="true"
                            @recherche="loadAffectationOfFaces"/>
            </div>
          </div>
          <div class="columns" v-if="faceMotifNonComId">
            <p class="column center">
                {{ $t('emplacementDispositifMaterielFacePicker.tab.nonCommercialisable') }}
            </p>
          </div>
        </div>
        <div v-if="affectationsList.length > 0 && !isLogistique">
          <div v-for="(affectation, index) in affectationsList" :key="index" >
            <div class="columns">
              <div class="column is-narrow has-text-link">
                <b-field class="has-text-weight-bold mgb-0">
                  <div class="mgr-5px">
                    {{ getLibelleTypeAffectation(affectation) }}
                  </div>
                  <router-link-blank :to="{ name: getRouteName(affectation),
                    params: { id: affectation.referenceId }}"
                                     :message="getCode(affectation)"/>
                  <div v-if="affectation.typeReference === COMMANDER"
                       class="mgl-5px">
                    {{ affectation.libelle }}
                  </div>
                </b-field>
                <p class="is-italic has-text-default is-size-7">
                  {{ getLibelleDate(affectation.dureeAffectation.dateDebut,
                  affectation.dureeAffectation.dateFin) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="affectationsList.length > 0 && isLogistique">
          <div v-for="(affectation, index) in affectationsList" :key="index" >
            <div class="columns">
              <div class="column is-narrow has-text-link">
                <router-link-blank :to="{ name: 'c.logistique.tournee_modele',
                    params: { id: affectation.tournee ? affectation.tournee.id : ''} }"
                    :message="affectation.tournee ? affectation.tournee.libelle : ''">
                </router-link-blank>
              </div>
            </div>
          </div>
        </div>
        <p class="center has-text-weight-bold" v-else>
          {{ traduction.noAffectation }}
        </p>
        <div class="center mgt-20px">
          <div class="button" @click="$parent.close">
            {{ $t('popUpAffectationFace.actions.fermer') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  CATEGORIE_PRODUIT,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
} from '@/configuration/catalogue/produitConf';
import { COMMANDER } from '@/configuration/affectation/affectationConf';
import formatDate from '@/services/general/formatDate';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import datePicker from '@/components/general/datePicker';
import loadAffectationOfFaces from '@/services/affectation/loadAffectation';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'GeneralInformationAffectationFace',
  components: {
    RouterLinkBlank,
    datePicker,
  },
  props: {
    affectations: {
      required: false,
      type: Array,
      default: null,
    },
    traduction: {
      required: true,
      type: Object,
    },
    faceMotifNonComId: {
      type: String,
      default: null,
    },
    periode: {
      required: false,
      type: Object,
      default: null,
    },
    facesList: {
      type: Array,
      default: null,
    },
    face: {
      type: Object,
      default: null,
    },
    isFromLigneFace: {
      type: Boolean,
      required: true,
      default: false,
    },
    isLogistique: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      COMMANDER: COMMANDER,
      affectationsList: this.affectations,
      intervalDeDate: this.periode,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getRouteName(affectation) {
      if (affectation.typeReference === COMMANDER) {
        if (affectation.commandeInterne
          && affectation.commandeInterne.societeId === this.societeActiveId) {
          return 'c.bodac.commandes-venteInterne';
        }
        return 'c.bodac.commandes';
      }
      if (affectation.sousTypeReference === CATEGORIE_REGROUPEMENT) return 'c.bodac.catalogue-reseau';
      if (affectation.sousTypeReference === CATEGORIE_REGROUPEMENT_LC) return 'c.bodac.catalogue-reseauLc';
      return 'c.bodac.catalogue-reseauNumerique';
    },
    getCode(affectation) {
      if (affectation.typeReference === COMMANDER) {
        if (affectation.commandeInterne
          && affectation.commandeInterne.societeId === this.societeActiveId) {
          return affectation.commandeInterne.code;
        }
        return affectation.codeReference;
      }
      return affectation.libelle;
    },
    getLibelleSousTypeReference(sousTypeReference) {
      const categorieFind = CATEGORIE_PRODUIT.find((categorie) => {
        return categorie.code === sousTypeReference;
      });
      return categorieFind ? this.$i18n.t(categorieFind.libelle) : null;
    },
    getLibelleTypeAffectation(affectation) {
      switch (affectation.typeReference) {
        case COMMANDER:
          return this.$i18n.t('popUpAffectationFace.commande');
        default:
          return this.getLibelleSousTypeReference(affectation.sousTypeReference);
      }
    },
    getLibelleDate(dateDebut, dateFin) {
      if (!dateFin) return this.$i18n.t('popUpAffectationFace.date.dateDebut', { dateDebut: formatDate(dateDebut) });
      return this.$i18n.t('popUpAffectationFace.date.periodeComplete', { dateDebut: formatDate(dateDebut), dateFin: formatDate(dateFin) });
    },
    async loadAffectationOfFaces() {
      const result = await loadAffectationOfFaces(
        this.facesList,
        this.intervalDeDate.dateDebut,
        this.intervalDeDate.dateFin,
      );
      this.affectationsList = this.getAffectation(this.face, result);
      this.affectationsList.sort((a, b) => {
        return moment(b.dureeAffectation.dateDebut) - moment(a.dureeAffectation.dateDebut);
      });
      return this.affectationsList;
    },
    getAffectation(face, affectations) {
      let affectation = null;
      affectation = affectations[face.produitId];
      return affectation;
    },
  },
  mounted() {
    this.affectationsList = cloneDeep(this.affectations);
    this.intervalDeDate = cloneDeep(this.periode);
  },
};

</script>
